import type { ColumnDef } from '@tanstack/react-table'

import { CounterCell, HumanizedDateCell } from '@/components'
import type { Folder, FolderKind } from '../../stores/types'
import { ContextMenuCell } from './ContextMenuCell'
import { NameCell } from './NameCell'
import { RowActionsCell } from './RowActionsCell'

const counterColumnByKind: Record<
  FolderKind,
  { accessorKey: keyof Folder; header: string; suffix: string }
> = {
  project: {
    accessorKey: 'numberOfProjects',
    header: '# of Projects',
    suffix: 'project',
  },
  document: {
    accessorKey: 'numberOfDocuments',
    header: '# of Documents',
    suffix: 'document',
  },
}

export const createFolderColumns = (
  kind: FolderKind,
): ColumnDef<Folder, any>[] => {
  const counter = counterColumnByKind[kind]

  return [
    {
      accessorKey: 'name',
      header: 'Folder Name',
      meta: { isFluid: true },
      size: 200,
      cell: ContextMenuCell(NameCell),
    },
    {
      accessorKey: 'updatedAt',
      header: 'Last Updated',
      size: 120,
      cell: ContextMenuCell(HumanizedDateCell),
    },
    {
      accessorKey: counter.accessorKey,
      header: counter.header,
      size: 130,
      cell: ContextMenuCell((cell) => (
        <CounterCell
          cell={cell}
          suffix={counter.suffix}
          className="text-left text-muted-foreground"
        />
      )),
    },
    {
      id: 'actions',
      header: '',
      size: 56,
      enableSorting: false,
      enableHiding: false,
      cell: RowActionsCell,
    },
  ]
}
